import guidelineSvg from "../assets/guideline.svg";

type SmileSimulationCaptureGuideProps = {
  message: string;
};

export function SmileSimulationCaptureGuide({
  message,
}: SmileSimulationCaptureGuideProps) {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 z-10"
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 36%, rgba(19,7,31,0.18) 72%, rgba(19,7,31,0.32) 100%)",
        }}
      />

      <div className="absolute inset-x-5 top-5 flex justify-center">
        <div className="bg-[#13071f]/52 max-w-[17rem] rounded-full border border-white/15 px-4 py-2 text-center text-[11px] font-medium leading-4 text-white/95 shadow-[0_10px_28px_rgba(19,7,31,0.35)] backdrop-blur-sm sm:text-xs">
          {message}
        </div>
      </div>

      <div className="absolute inset-0 flex justify-center">
        <img
          src={guidelineSvg}
          alt=""
          draggable={false}
          className="mt-[25%] h-[90%] w-auto max-w-[120%] opacity-85 [filter:brightness(3.1)_grayscale(1)_drop-shadow(0_0_18px_rgba(255,255,255,0.2))]"
        />
      </div>
    </div>
  );
}
